import { Injectable, Pipe } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { map } from 'rxjs/operators';


function _window() : any {
  return window;
}
@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  get nativeWindow() : any {
    return _window();
 }
  constructor(private http:Http) { }

  // to set & get the data from API
  PostService(url, reqObj){
    let headers = new Headers({ 'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    
    return this.http.post(url, reqObj, options ).
    pipe(map((res: Response) => res.json()))
  }
}
